// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    blackButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Black Button Text",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    whiteButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "White Button Text",
        translatable: true
    },
    blackButtonLink: {
        type: FIELD_TYPES.NESTED,
        label: "Black Button Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
